import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-339f2b03")

_pushScopeId("data-v-339f2b03")
const _hoisted_1 = { class: "filter-flight flex flex-row gap-x-3" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  class: "flex flex-col gap-y-4 p-3",
  style: {"min-width":"208px"}
}
const _hoisted_5 = { class: "text-xs font-semibold text-black-lp-100 mb-2" }
const _hoisted_6 = { class: "flex flex-row gap-x-8 pr-3 text-sm" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", {
  class: "bg-gray-lp-200 w-full",
  style: {"height":"1px"}
}, null, -1)
const _hoisted_8 = { class: "text-xs font-semibold text-black-lp-100 mb-2" }
const _hoisted_9 = { class: "flex flex-row gap-x-8 pr-3" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  class: "flex flex-col gap-y-4 p-3",
  style: {"min-width":"208px"}
}
const _hoisted_13 = { class: "text-xs font-semibold text-black-lp-100 mb-2" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  class: "flex flex-col py-3",
  style: {"min-width":"208px"}
}
const _hoisted_17 = { class: "text-xs font-semibold text-black-lp-100 px-3 mb-2" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "font-semibold" }
const _hoisted_20 = { class: "flex flex-col py-3" }
const _hoisted_21 = { class: "text-xs font-semibold text-black-lp-100 px-3 mb-2" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_PillOverlay = _resolveComponent("PillOverlay")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_PillOverlay, {
      active: _ctx.airportsActive,
      "show-clear": _ctx.airportsActive,
      onClear: _ctx.onResetAirports,
      onToggle: _ctx.onToggleAirports,
      onApply: _ctx.onApplyAirports,
      "disabled-reset": !_ctx.airportsActive,
      "disabled-apply": _ctx.isApplyDisabled,
      disabled: _ctx.disabledFlight,
      showActions: ""
    }, {
      trigger: _withId(() => [
        _createVNode(_component_Icons, {
          name: "ics_o_plane",
          style: {"width":"16px","height":"16px"}
        }),
        (_ctx.airportsActive)
          ? (_openBlock(), _createBlock("span", _hoisted_2, _toDisplayString(_ctx.fullAirportRouteDisplay), 1))
          : (_openBlock(), _createBlock("span", _hoisted_3, _toDisplayString(_ctx.$t("cargo.v2.flight.search.filter.selectAirport")), 1))
      ]),
      content: _withId(() => [
        _createVNode("div", _hoisted_4, [
          _createVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("cargo.v2.flight.search.filter.originAirport")), 1),
          _createVNode("div", _hoisted_6, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.originAirportOptionsValue, (airport) => {
              return (_openBlock(), _createBlock("div", {
                key: airport.value,
                class: "flex flex-row gap-x-2"
              }, [
                _createVNode(_component_Checkbox, {
                  value: airport.value,
                  label: airport.label,
                  id: airport.value,
                  modelValue: _ctx.tempOriginAirports,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.tempOriginAirports = $event))
                }, null, 8, ["value", "label", "id", "modelValue"]),
                _createVNode("label", {
                  for: airport.value
                }, _toDisplayString(airport.label), 9, ["for"])
              ]))
            }), 128))
          ]),
          _hoisted_7,
          _createVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("cargo.v2.flight.search.filter.destinationAirport")), 1),
          _createVNode("div", _hoisted_9, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.destinationAirportOptionsValue, (airport) => {
              return (_openBlock(), _createBlock("div", {
                key: airport.value,
                class: "flex flex-row gap-x-2"
              }, [
                _createVNode(_component_Checkbox, {
                  value: airport.value,
                  label: airport.label,
                  id: airport.value,
                  modelValue: _ctx.tempDestinationAirports,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.tempDestinationAirports = $event))
                }, null, 8, ["value", "label", "id", "modelValue"]),
                _createVNode("label", {
                  for: airport.value
                }, _toDisplayString(airport.label), 9, ["for"])
              ]))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["active", "show-clear", "onClear", "onToggle", "onApply", "disabled-reset", "disabled-apply", "disabled"]),
    _createVNode(_component_PillOverlay, {
      active: _ctx.legsActive,
      "show-clear": _ctx.legsActive,
      onClear: _ctx.onResetLegs,
      onToggle: _ctx.onToggleLegs,
      onApply: _ctx.onApplyLegs,
      "disabled-reset": !_ctx.legsActive,
      "disabled-apply": _ctx.isApplyDisabledLegs,
      showActions: ""
    }, {
      trigger: _withId(() => [
        _createVNode(_component_Icons, {
          name: "route",
          style: {"width":"16px","height":"16px"}
        }),
        (_ctx.legsActive)
          ? (_openBlock(), _createBlock("span", _hoisted_10, _toDisplayString(_ctx.legsLabel), 1))
          : (_openBlock(), _createBlock("span", _hoisted_11, _toDisplayString(_ctx.$t("cargo.v2.flight.search.filter.transitCount")), 1))
      ]),
      content: _withId(() => [
        _createVNode("div", _hoisted_12, [
          _createVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("cargo.v2.flight.search.filter.selectTransitCount")), 1),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.legsOptions, (leg) => {
            return (_openBlock(), _createBlock("div", {
              key: leg.value,
              class: "flex flex-row gap-x-2 text-sm"
            }, [
              _createVNode(_component_Checkbox, {
                value: leg.value,
                label: leg.label,
                id: leg.value.toString(),
                modelValue: _ctx.tempLegs,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.tempLegs = $event))
              }, null, 8, ["value", "label", "id", "modelValue"]),
              _createVNode("label", {
                for: leg.value.toString()
              }, _toDisplayString(leg.label), 9, ["for"])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["active", "show-clear", "onClear", "onToggle", "onApply", "disabled-reset", "disabled-apply"]),
    _createVNode(_component_PillOverlay, {
      active: _ctx.sortPillActive,
      "show-clear": _ctx.sortPillActive,
      onClear: _ctx.onResetSort
    }, {
      trigger: _withId(() => [
        _createVNode(_component_Icons, {
          name: "view",
          style: {"width":"16px","height":"16px"}
        }),
        (_ctx.selectedSort)
          ? (_openBlock(), _createBlock("span", _hoisted_14, _toDisplayString(_ctx.sortLabel), 1))
          : (_openBlock(), _createBlock("span", _hoisted_15, _toDisplayString(_ctx.$t("cargo.v2.flight.search.filter.sort")), 1))
      ]),
      content: _withId(({ close }) => [
        _createVNode("div", _hoisted_16, [
          _createVNode("span", _hoisted_17, _toDisplayString(_ctx.$t("cargo.v2.flight.search.filter.selectSort")), 1),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sortOptions, (sort) => {
            return (_openBlock(), _createBlock("div", {
              key: sort.value,
              class: "flex flex-row text-sm"
            }, [
              _createVNode("button", {
                class: ["text-sm text-black-lp-100 py-2 w-full text-left hover:bg-gray-100 px-3", { underline: _ctx.externalSelectedSort === sort.value }],
                onClick: ($event: any) => {
                _ctx.hasUserChangedSort = true;
                _ctx.externalSelectedSort = sort.value;
                close();
              }
              }, _toDisplayString(sort.label), 11, ["onClick"])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["active", "show-clear", "onClear"]),
    _createVNode(_component_PillOverlay, {
      active: _ctx.thresholdTimeActive,
      "disabled-reset": !_ctx.thresholdTimeActive,
      "overlay-position": "bottom-right"
    }, {
      trigger: _withId(() => [
        _createVNode(_component_Icons, {
          name: "clock-v3",
          style: {"width":"16px","height":"16px"}
        }),
        (_ctx.thresholdTimeActive)
          ? (_openBlock(), _createBlock("span", _hoisted_18, [
              _createTextVNode(_toDisplayString(_ctx.$t("cargo.v2.flight.search.filter.thresholdTime")) + " ", 1),
              _createVNode("span", _hoisted_19, _toDisplayString(_ctx.thresholdTimeLabel), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      content: _withId(({ close }) => [
        _createVNode("div", _hoisted_20, [
          _createVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("cargo.v2.flight.search.filter.selectThreshold")), 1),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.thresholdTimeOptions, (thresholdTime) => {
            return (_openBlock(), _createBlock("div", {
              key: thresholdTime.value,
              class: "flex flex-row text-sm"
            }, [
              _createVNode("button", {
                class: ["text-sm text-black-lp-100 py-2 w-full hover:bg-gray-100 px-3", {
                underline:
                  _ctx.externalSelectedThresholdTime === thresholdTime.value,
              }],
                onClick: ($event: any) => {
                _ctx.externalSelectedThresholdTime = thresholdTime.value;
                close();
              }
              }, _toDisplayString(thresholdTime.label), 11, ["onClick"])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["active", "disabled-reset"])
  ]))
})